// extracted by mini-css-extract-plugin
module.exports = {"Blackberry":"#333D47","FontWeightBold":"600","navExtenedItemLink":"HeaderNavExtendedItemLink_navExtenedItemLink__3nqv9 typography_fontStyleBody__36tzv"};